import { render, staticRenderFns } from "./KLineChart.vue?vue&type=template&id=bafb86e6&scoped=true"
import script from "./KLineChart.vue?vue&type=script&lang=js"
export * from "./KLineChart.vue?vue&type=script&lang=js"
import style0 from "./KLineChart.vue?vue&type=style&index=0&id=bafb86e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafb86e6",
  null
  
)

export default component.exports